import React from "react";
import CheckoutContext from "../../checkout-context";

class SidebarRemarks extends React.Component {
    constructor(props) {
        super(props);
    }

    static contextType = CheckoutContext;

    render() {
        const {
            data: checkoutData,
            checkDiscountActive,
            textsMapping,
        } = this.context;

        const {
            checkoutMemberShipDiscountText,
            checkoutMemberShipNoDiscountText,
        } = textsMapping;

        return (
            <div className="checkout__sidebar-remarks">
                {checkoutData.isMember || checkDiscountActive
                    ? <span className="color--primary">{checkoutMemberShipDiscountText}</span>
                    : checkoutMemberShipNoDiscountText !== ''
                        ? <span>{checkoutMemberShipNoDiscountText}</span>
                        : null
                }
            </div>
        )
    }
}

export {SidebarRemarks};